import React, { useEffect, useState } from 'react';
import { Button, Card, Form } from '@douyinfe/semi-ui';
import Title from '@douyinfe/semi-ui/lib/es/typography/title';
import Text from '@douyinfe/semi-ui/lib/es/typography/text';
import { API, copy, showError, showNotice } from '../helpers';
import { useSearchParams } from 'react-router-dom';

const PasswordResetConfirm = () => {
  const [inputs, setInputs] = useState({
    email: '',
    token: ''
  });
  const { email, token } = inputs;

  const [loading, setLoading] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [countdown, setCountdown] = useState(30);
  const [newPassword, setNewPassword] = useState('');

  const [searchParams, setSearchParams] = useSearchParams();
  
  useEffect(() => {
    let token = searchParams.get('token');
    let email = searchParams.get('email');
    setInputs({
      token,
      email
    });
  }, []);

  useEffect(() => {
    let countdownInterval = null;
    if (disableButton && countdown > 0) {
      countdownInterval = setInterval(() => {
        setCountdown(countdown - 1);
      }, 1000);
    } else if (countdown === 0) {
      setDisableButton(false);
      setCountdown(30);
    }
    return () => clearInterval(countdownInterval);
  }, [disableButton, countdown]);

  async function handleSubmit(e) {
    setDisableButton(true);
    if (!email) return;
    setLoading(true);
    const res = await API.post(`/api/user/reset`, {
      email,
      token
    });
    const { success, message } = res.data;
    if (success) {
      let password = res.data.data;
      setNewPassword(password);
      await copy(password);
      showNotice(`新密码已复制到剪贴板：${password}`);
    } else {
      showError(message);
    }
    setLoading(false);
  }

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: '#f5f7fa',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{ width: '100%', maxWidth: '480px' }}>
        {/* Logo 和标题 */}
        <div style={{ 
          textAlign: 'center', 
          marginBottom: '32px'
        }}>
          <Title heading={2} style={{ 
            margin: 0, 
            color: '#303133',
            fontWeight: '600'
          }}>
            密码重置确认
          </Title>
          <Text style={{ 
            color: '#909399', 
            marginTop: '8px',
            fontSize: '14px'
          }}>
            确认重置您的账户密码
          </Text>
        </div>

        <Card 
          style={{ 
            boxShadow: '0 2px 12px 0 rgba(0, 0, 0, 0.1)',
            borderRadius: '4px',
            border: '1px solid #e4e7ed'
          }}
        >
          <div style={{ padding: '32px' }}>
            <Form>
              <Form.Input
                field={'email'}
                label={'邮箱地址'}
                placeholder="邮箱地址"
                name="email"
                value={email}
                readOnly
                size="large"
                style={{ marginBottom: '20px' }}
              />
              {newPassword && (
                <Form.Input
                  field={'newPassword'}
                  label={'新密码'}
                  placeholder="新密码"
                  name="newPassword"
                  value={newPassword}
                  readOnly
                  size="large"
                  style={{ marginBottom: '24px' }}
                  onClick={(e) => {
                    e.target.select();
                    navigator.clipboard.writeText(newPassword);
                    showNotice(`密码已复制到剪贴板：${newPassword}`);
                  }}
                />
              )}
              <Button 
                theme="solid" 
                style={{ 
                  width: '100%',
                  background: '#409eff',
                  border: 'none',
                  height: '40px',
                  fontSize: '14px',
                  fontWeight: '500',
                  borderRadius: '4px'
                }} 
                type={'primary'} 
                size="large"
                loading={loading}
                disabled={disableButton}
                onClick={handleSubmit}>
                {disableButton ? '密码重置完成' : '提交'}
              </Button>
            </Form>
          </div>
        </Card>

        {/* 底部版权信息 */}
        <div style={{ 
          textAlign: 'center', 
          marginTop: '32px',
          color: '#c0c4cc',
          fontSize: '12px'
        }}>
          © 2026 AI API Platform. All rights reserved.
        </div>
      </div>
    </div>
  );
};

export default PasswordResetConfirm;
